import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import data from '../Database/data'

const Houses = () => {
  const [houses, setHouse] = useState(data)
  const [index, setIndex] = useState(0)
  //setting exact positions for slides positive and negative
  useEffect(() => {
    const lastIndex = houses.length - 1
    if (index < 0) {
      setIndex(lastIndex)
    }
    if (index > lastIndex) setIndex(0)
  }, [index, houses])

  //setting auto slide
  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index - 1)
    }, 3000)
    return () => clearInterval(slider)
  }, [index])

  return (
    <Wrapper className='section-center'>
      <div className='section-center'>
        {houses.map((house, houseIndex) => {
          const { id, image, name } = house

          //seting slides
          let position = 'nextSlide'
          if (houseIndex === index) {
            position = 'activeSlide'
          }
          if (
            houseIndex === index - 1 ||
            (index === 0 && houseIndex === houses.length - 1)
          ) {
            position = 'lastSlide'
          }
          return (
            <article className={position} key={id}>
              <img src={image} alt={name} className='house-img' />
              <h4>{name}</h4>
            </article>
          )
        })}
        
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  min-height: 60vh;
  display: grid;
  place-items: center;
  .img-container {
    display: none;
  }
  @media (min-width: 992px) {
    height: calc(100vh - 5rem);
    grid-template-columns: 1fr 1fr;
    gap: 8rem;

    .section-center {
      margin: 0 auto;
      margin-top: 1rem;
      width: 150vw;
      // has to have a height
      height: 400px;
      max-width: 1250px;
      text-align: center;
      position: relative;
      display: flex;
      overflow: hidden;
    }
    .house-img {
      border-radius: 0%;
      margin-bottom: 1rem;
      width: 1250px;
      height: 300px;
      object-fit: cover;
      border: 4px solid var(--clr-grey-8);
      box-shadow: wheat;
    }
    article h4 {
      text-transform: uppercase;
      color: brown;
      margin-bottom: 0.25rem;
    }
    @media only screen and (max-width: 992px) {
      .text {
        max-width: 45em;
      }
      .house-img .prev,
      .next {
        width: 50%;
        height: 50%;
        font-size: 1.5rem;
      }
    }
    /* to set slider*/
    article {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: var(--transition);
    }
    article.activeSlide {
      opacity: 1;
      transform: translateX(0);
    }

    article.lastSlide {
      transform: translateX(-100%);
    }

    article.nextSlide {
      transform: translateX(100%);
    }
  }
`

export default Houses
